import en from './onboarding.en';

const enConfig = { en };

export default enConfig;
